import { useMemo } from 'react';

export const useIsDivisible = (puntataInputValue: number) => {
  return useMemo(() => {
    const num = parseFloat((puntataInputValue * 100).toFixed(4));
    return num % (0.05 * 100) === 0;
  }, [puntataInputValue]);
};
